$(document).ready(function () {

    $('body').on('change', '.enquiryForm #callback', function () {

        if ($(this).val() === 'Other') {
            $(this).parents('.enquiryForm').find('.hiddenOtherRow').slideDown();
        } else {
            $(this).parents('.enquiryForm').find('.hiddenOtherRow').slideUp();
        }

    });

    submitForm('.enquiryForm');

    $('.enquireOverlay').mtcOverlay({
        buttonHtml: '<div class="altCloseButton overlayCloseButton enquireClose"><a href="#"><img class="enquireCloseSVG" src="/sites/petervardy/images/svgs/times-dark.svg" alt="Close Popup" /></a></div>',
        onOpen: function () {
            let recaptchaV3Field = $('.overlayBox').find('.g-recaptcha-response-v3')

            if (recaptchaV3Field.length > 0) {
                recaptchaInitV3()
            }

            var windowHeight = $(window).height(),
                overlayHeight = (windowHeight);

            if($(window).width() < window.breakpoints.mobile) {

                $('.enquireOverlay.overlayForm').height(overlayHeight);
                $('.overlayBox').css({'top': 0});

                $('.enquireOverlay').scroll(function() {

                    var header_height = 50,
                        $element = $('.enquireClose'),
                        offset,
                        off_top;

                    offset = $('.enquireOverlay form').offset();

                    if (offset.top < header_height /*&& !is_touch_device()*/) {
                        // user scrolled passed header
                        $element.addClass('stickMe');
                    } else {
                        $element.removeClass('stickMe');
                    }

                });
            }
        }
    });

});
